import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;

let initialized = false;

export function initAnalytics() {
  if (!POSTHOG_KEY || initialized) return;
  posthog.init(POSTHOG_KEY, {
    api_host: 'https://us.i.posthog.com',
    autocapture: false,
    capture_pageview: false,
  });
  initialized = true;
}

export function capture(event: string, properties?: Record<string, unknown>) {
  if (!initialized) return;
  posthog.capture(event, properties);
}

export function captureError(error: unknown, context?: string) {
  const message = error instanceof Error ? error.message : String(error);
  const stack = error instanceof Error ? error.stack : undefined;
  capture('client_error', { message, stack, context });
}

export function installGlobalErrorHandlers() {
  window.onerror = (_msg, source, line, col, error) => {
    captureError(error ?? _msg, `global:${source}:${line}:${col}`);
  };
  window.addEventListener('unhandledrejection', (e) => {
    captureError(e.reason, 'unhandledrejection');
  });
}
